<script setup lang="ts">
import { computed } from 'vue';
import { Menu } from '~/types';
import { resolveSocialNetworkIconComponent } from '~/composables/useSocialNetworkImage';
import { resolveSocialNetworkName } from '~/composables/useSocialNetworkName';
import ExternalLinkWarning from '../ui/ExternalLinkWarning.vue';

interface Props {
  item: Menu.MenuItem;
  navPos?: string;
  navLayer?: string;
}

const props = defineProps<Props>();
const links = computed<Menu.LinkNetwork[]>(() => (Array.isArray(props.item?.data) ? props.item.data : []));
</script>

<template>
  <li class="social">
    <template v-if="links && links.length > 0">
      <a
        v-for="(link, index) in links"
        :key="`social-link-${index}`"
        :href="link.link"
        target="_blank"
        rel="noopener"
        class="social__link"
      >
        <span class="social__name">{{ resolveSocialNetworkName(link.network) }}</span>
        <Component
          :is="resolveSocialNetworkIconComponent(link.network)"
          v-if="resolveSocialNetworkIconComponent(link.network)"
          class="social__icon"
        />
        <ExternalLinkWarning />
      </a>
    </template>
  </li>
</template>

<style lang="scss" scoped>
.social {
  &__name {
    @apply hidden;
  }

  &__icon {
    @apply w-5 h-5 duration-300 fill-base-color hover:fill-accent;
  }
}
</style>
